import ResourcePlanningPage from 'pages/ResourcePlanning';
import autoformPlaceholder from '../images/autoform-unselected.png';
import { Navigate } from 'react-router-dom';
import AutoformPage from 'pages/AutoformPage';
import WrapperEmptyState from 'components/layout/WrapperEmptyState';
import AutoformContainer from 'components/autoform/AutoformContainer';
import { RESOURCE_PLANNING_ROUTES } from 'constants/routes';

export const resourcePlanningRoutes = {
    path: '/resource-planning',
    element: <ResourcePlanningPage />,
    children: [
        {
            index: true,
            element: <Navigate to={`${RESOURCE_PLANNING_ROUTES.ECONOMIC_ASSUMPTION}/${window.location.search}`} />,
        },
        {
            path: RESOURCE_PLANNING_ROUTES.ECONOMIC_ASSUMPTION,
            element: (
                <AutoformPage
                    config={{ autoformId: RESOURCE_PLANNING_ROUTES.ECONOMIC_ASSUMPTION }}
                    hasSecondaryMenu={true}
                />
            ),
            children: [
                {
                    index: true,
                    element: (
                        <WrapperEmptyState imgSrc={autoformPlaceholder} item="record" page="left" noun="properties" />
                    ),
                },
                {
                    path: ':itemId',
                    element: <AutoformContainer />,
                },
            ],
        },
        {
            path: RESOURCE_PLANNING_ROUTES.OBJECTIVE_FUNCTION,
            element: (
                <AutoformPage
                    config={{ autoformId: RESOURCE_PLANNING_ROUTES.OBJECTIVE_FUNCTION }}
                    hasSecondaryMenu={true}
                />
            ),
            children: [
                {
                    index: true,
                    element: (
                        <WrapperEmptyState imgSrc={autoformPlaceholder} item="record" page="left" noun="properties" />
                    ),
                },
                {
                    path: ':itemId',
                    element: <AutoformContainer />,
                },
            ],
        },
        {
            path: RESOURCE_PLANNING_ROUTES.PLANNING_CONSTRAINTS,
            element: (
                <AutoformPage
                    config={{ autoformId: RESOURCE_PLANNING_ROUTES.PLANNING_CONSTRAINTS }}
                    hasSecondaryMenu={true}
                />
            ),
            children: [
                {
                    index: true,
                    element: (
                        <WrapperEmptyState imgSrc={autoformPlaceholder} item="record" page="left" noun="properties" />
                    ),
                },
                {
                    path: ':itemId',
                    element: <AutoformContainer />,
                },
            ],
        },
        {
            path: RESOURCE_PLANNING_ROUTES.PROJECT_DETAILS,
            element: (
                <AutoformPage
                    config={{ autoformId: RESOURCE_PLANNING_ROUTES.PROJECT_DETAILS }}
                    hasSecondaryMenu={true}
                />
            ),
            children: [
                {
                    index: true,
                    element: (
                        <WrapperEmptyState imgSrc={autoformPlaceholder} item="record" page="left" noun="properties" />
                    ),
                },
                {
                    path: ':itemId',
                    element: <AutoformContainer />,
                },
            ],
        },
    ],
};
